<template>
  <div>
    <v-snackbar
      class="mt-5 snack-text-center"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>

    <v-container class="verification-link">
      <v-layout row>
        <v-flex xs6 offset-xs3>
          <v-card class="border-all-1 corner-all-10 box_s container">
            <h3>User Verification</h3>
            <v-card-text class="pl0">
              <v-text-field
                v-model="user_email"
                label="Email"
                v-validate="'required'"
                data-vv-name="email"
                disabled
                :error-messages="errors.collect('email')"
              ></v-text-field>
              <v-text-field
                v-model="emailVerifyCode"
                label="Verification Code"
                v-validate="{required: true, alpha_num: true}"
                data-vv-name="code"
                :error-messages="errors.collect('code')"
              ></v-text-field>

            </v-card-text>
            <v-card-actions class="pl0">
                
              <vue-recaptcha v-if="!(emailVerified)" id="recaptcha" ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSiteKey" size="invisible">
              </vue-recaptcha>
              <v-btn color="primary" :disabled="!verificationCodeValid" v-if="!(emailVerified)" @click="initiateEmailVerification()">Verify Email</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'emailUpdateVerification',
  components: { VueRecaptcha },
  data: () => ({
    color: '',
    alert: false,
    message: '',
    user_email: '',
    emailVerifyCode: '',
    emailVerified: false,
    recaptcha_response: ''
  }),
  computed: {
    getUserEmail () {
      // console.log(this.$route, this.$route.query.email)
      return this.$route.query.email || ''
    },
    verificationCodeValid () {
      // console.log(this.emailVerifyCode && this.fields.code && this.fields.code.valid)
      return this.emailVerifyCode && this.fields && this.fields.code && this.fields.code.valid
    },
    recaptchaSiteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  mounted () {
    this.user_email = this.getUserEmail
  },
  methods: {
    onCaptchaVerified (res) {
      // console.log('onCaptchaVerified >> ', res)
      if (res && res.length) {
        this.recaptcha_response = res
        this.verifyEmail()
      } else {
        this.color = 'error'
        this.message = 'Error in verifying the reCAPTCHA'
        this.alert = true
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    initiateEmailVerification () {
      this.$refs.recaptcha.execute()
    },
    verifyEmail () {
      console.log('token :: ', this.recaptcha_response)
      if (this.recaptcha_response && this.verificationCodeValid) {
        let reqBody = {
          'email': this.user_email,
          'tempPassword': this.emailVerifyCode,
          'g-recaptcha-response': this.recaptcha_response,
          'id': this.$route.query.id
        }
        this.$store.dispatch('ACTION_VERIFY_UPDATE_EMAIL', reqBody).then((res) => {
          if (res.success) {
              this.color = 'success'
              this.message = "Primary Email Updated Successfully!"
              this.alert = true
              this.emailVerified = true
              setTimeout(() => {
                this.$router.push('/')
              }, 3000)
          } else if (res.error && (res.error.internalMessage == "Wrong code entered" || res.error.message == "Wrong code entered")) {
              this.color = 'error'
              this.message = "Please enter correct verification code."
              this.alert = true
          } else {
            this.color = 'error'
            this.message = res.error.internalMessage || res.error.message || 'Verification link invalid/expired. Please try to resend the verification link.'
            this.alert = true
            setTimeout(() => {
              this.$router.push('/')
            }, 3000)
          }
        })
      }
    },
  }
}
</script>

<style>
.verification-link {
  margin-top: 20vh
}
</style>
